<template>
  <div>
    <input type="checkbox" :id="checkboxId" class="riclothes-checkbox" @input="$emit('change', $event.target.checked)" v-bind="{ checked: isChecked }" />
    <label class="riclothes-checkbox--label" :class="labelStyleObject" v-bind="{ for: checkboxId }">{{ text }}</label>
  </div>
</template>

<script>
export default {
  name: "ri-clothes-checkbox",
  props: {
    isChecked: Boolean,
    checkboxId: String,
    text: String,
    color: {
      color: String,
      default: "default"
    }
  },
  model: {
    prop: "isChecked",
    event: "change"
  },
  watch: {
    isChecked: function() {
      this.$emit("onChangeValue", this.isChecked);
    }
  },
  computed: {
    labelStyleObject: function() {
      let isCustomColor = false;
      if(this.color != "default" && this.color != "") {
        isCustomColor = true;
      }
      return {
        [`riclothes-checkbox--label__${this.color}`]: isCustomColor
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.riclothes-checkbox {

  display: none;

  &--label {
    --checkbox-color: var(--text-color);

    &__white {
      --checkbox-color: #ffffff;
    }

    &__black {
      --checkbox-color: #000000;
    }

    color: var(--checkbox-color);
    transition: 0.5s;
    font-size: 1.25rem;
    position: relative;
    padding-left: 40px;
    height: 24px;

    &:before {
      font-family: "Material Icons";
      box-sizing: border-box;
      position: absolute;
      top: 50%;
      left: 0;
      width: 24px;
      height: 24px;
      content: "";
      border-style: solid;
      border-color: var(--checkbox-color);
      border-width: 2px;
      margin-top: -12px;
      margin-left: 8px;
    }
  }

  &:checked + .riclothes-checkbox--label {
    &:before {
      content: "\e5ca";
    }
  }
}
</style>